var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHoverArrowi = function SvgHoverArrowi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "none",
    stroke: "#dfe2e5"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    d: "M14.5 15.8 10.8 12l3.7-3.8L13.4 7l-4.9 5 4.9 5z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHoverArrowi);
export default ForwardRef;